import React, { type ComponentProps, forwardRef } from "react";

import { cn } from "@/lib/helpers/cn";

type BodyProps = {
  children: React.ReactNode;
  className?: string;
} & ComponentProps<"div">;

export const Body = forwardRef<HTMLDivElement, BodyProps>(
  ({ children, className, ...props }: BodyProps, ref) => (
    <div
      className={cn(
        "tw:justify-between tw:border tw:border-solid tw:border-fill-quinary tw:p-1.5",
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </div>
  ),
);

Body.displayName = "Schedule.Body";
